'use client';

import React from 'react';
import { connect } from 'react-redux';
import { DisplayField } from './DisplayField';

const FormFieldsInfo = ({ errors = {}, touched = {}, mobileInfo, firstName, familyName, gender }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', padding: '20px' }}>
      <DisplayField label='موبایل' value={mobileInfo} name='mobile' twoItemInOneRow={true} />
      <DisplayField label={'نام'} name='firstName' value={firstName} />
      <DisplayField label={'نام خانوادگی'} name='lastName' value={familyName} />
      <DisplayField label={'جنسیت'} name='gender' value={gender == 1 ? 'مرد' : 'زن'} />
    </div>
  );
};

const MapStateToProps = (state) => ({
  mobileInfo: state.user.mobile,
  userGroup: state.user.customers_group_title,
  firstName: state.user.name,
  familyName: state.user.family,
  gender: state.user.gender,
});
export default connect(MapStateToProps)(FormFieldsInfo);
